import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import AddtoCart from "./add-to-cart";
import ProductDescription from "./product-description";
import { useGetProductDetailsQuery } from "../../../services/productDetailAPI";
import RelatedProducts from "./related-products"
import Loader from "../fullPageLoader"

function Index() {
  const { id } = useParams();

  const { data, error, isLoading, refetch } = useGetProductDetailsQuery(id);
  useEffect(() => {
    refetch();
  }, [refetch])

  if (isLoading) return <Loader />;
  if (error) return <p>Error loading page content</p>;

  return (
    <div>
      <AddtoCart product={data?.product} />
      <ProductDescription product={data?.product} />
      <RelatedProducts productDetail={data?.product} />
    </div>
  );
}

export default Index;
